<script setup>

import { KNOLIA } from "@/knolia"
import { ref, defineEmits, onMounted } from "vue"

const emits = defineEmits(['close-profile-modal'])

const userData = ref({})
const defaultImg = ref(require('@/images/default.png'))
const isLowerThanMobile = ref(KNOLIA.updateIsLowerThanMobile())
const isMobile = ref(KNOLIA.updateIsMobile())

onMounted(async () => {
  const response = await KNOLIA.CallBackEnd('get', `get-user`)
  userData.value = response.data.user 

  window.addEventListener('resize', () => {
    isMobile.value = KNOLIA.updateIsMobile()
    isLowerThanMobile.value = KNOLIA.updateIsLowerThanMobile()
  })
})

</script>

<template>
  <div id="div-container-modal" class="div-modal">
    <div id="div-user-content" class="div-modal-content">
      <div class="close-modal">
        <i class="fas fa-times" @click="emits('close-profile-modal')"></i>
      </div>

      <div class="user-container">
        <div class="div-photo">
          <div class="photo">
            <img id="photo-usr" class="cover" :src="userData?.src ?? defaultImg" alt="user-image" @error="$event.target.src = defaultImg">
          </div>
        </div>

        <div class="div-separation-line"></div>

        <section class="section">
          <div class="row mb-4 w-100 p-0 m-0">
            <div class="col-4 ps-0">
              <label class="ps-0">N° INTERNO</label>
              <div class="w-100 div-fake-input" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}" >{{ userData.user_internal }}</div>
            </div>
            
            <div class="col-8 pe-0">
              <label class="ps-0">NOME PROFISSIONAL</label>
              <div class="w-100 div-fake-input" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}" >{{ userData.professional_name }}</div>
            </div>
          </div>

          <div class="row mb-4 w-100 p-0 m-0">
            <label class="ps-0">NOME COMPLETO</label>
              <div class="w-100 div-fake-input" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}" >{{ userData.complete_name }}</div>
          </div>

          <div class="row mb-4 w-100 p-0 m-0">
            <label class="ps-0">FUNÇÃO</label>
              <div class="w-100 div-fake-input" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}" >{{ userData.user_job }}</div>
          </div>

          <div class="row mb-4 w-100 p-0 m-0">
            <label class="ps-0">EMAIL</label>
              <div class="w-100 div-fake-input" :class="{'ddl-alt-padding': isMobile || isLowerThanMobile}" >{{ userData.user_email }}</div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>

.div-modal {
  position: fixed;
  color: var(--default-font-color);
}

.div-modal-content {
  position: absolute;
  top: 2%;
  left: 25%;
  transform: translate(0, 0);
  width: 45% !important;
}

.close-modal {
  display: flex;
  justify-content: flex-end;
  padding: 10px 10px 0px 0px;
}

.close-modal i {
  font-size: 1.5em;
  cursor: pointer;
}

.close-modal i:hover {
  color: var(--default-app-hover-color);
}

.user-container {
  text-align: left;
  display: flex;
  margin: 0px 30px 20px 30px;
}

.div-separation-line {
  display: inline-block;
  border-right: solid 2px var(--default-font-color);
  margin: 0 8% 0 8%;
}

.photo img {
  align-self: center;
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

.photo {
  align-self: center;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  box-shadow: 0 0 15px 5px rgba(30, 40, 50, .2);
  align-content: center;
  text-align-last: center;
}

.icon {
  font-size: 7em;
}

.cover {
  object-fit: cover;
  width: 150px;
  height: 100px;
}

.div-photo {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}

.section {
  font-size: .9em;
  width: 100%;
}

.div-fake-input {
  padding: var(--default-app-padding);
  border: 1px solid var(--default-font-color);
  border-radius: var(--default-app-radius);
  background-color: var(--default-app-alt-line-color);
}

@media screen and (max-width: 1015px) {

  .div-modal-content { 
    width: 80% !important;
    left: 10%;
  }
}

@media screen and (max-width: 765px) {

  .div-modal-content { 
    width: 100% !important;
    top: 15%;
    left: 0;
    padding: 2%;
  }

  .close-modal {
    padding: 0px;
  }

  .user-container {
    flex-direction: column;
    margin: 0px;
  }

  label {
    margin-left: 9px;
  }

  .photo {
    margin-bottom: 2%;
    margin-top: -15px;
  }

  .photo,
  .photo img {
    width: 100px;
    height: 100px;
  }
}

</style>